
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif"}},[_c('path',{attrs:{"d":"M4.341.546a.818.818 0 00-.818.818v1.815h-1.52C.96 3.18.016 3.978.016 5.051v10.534c0 1.072.943 1.87 1.987 1.87h14.025c1.044 0 1.988-.798 1.988-1.87V5.05c0-1.072-.944-1.87-1.988-1.87h-1.52V1.363a.818.818 0 00-.818-.818.818.818 0 00-.818.818v1.815H5.159V1.364a.818.818 0 00-.818-.818zm-2.338 4.27h1.52V6.63a.818.818 0 00.818.818.818.818 0 00.818-.818V4.816h7.713V6.63a.818.818 0 00.818.818.818.818 0 00.818-.818V4.816h1.52c.246 0 .351.142.351.234v10.534c0 .091-.105.234-.351.234H2.003c-.246 0-.35-.143-.35-.234V5.05c0-.091.104-.234.35-.234z","overflow":"visible"}}),_c('path',{attrs:{"d":"M9.016 7.342c-1.271 0-2.39.496-3.209 1.149-.82.653-1.428 1.429-1.428 2.396 0 .97.608 1.747 1.428 2.4.82.653 1.938 1.146 3.209 1.146 1.27 0 2.389-.493 3.208-1.146.82-.653 1.428-1.43 1.428-2.4 0-.968-.608-1.743-1.428-2.396-.82-.653-1.937-1.149-3.208-1.149zm0 1.636c.837 0 1.628.344 2.19.791.562.448.81 1.037.81 1.118 0 .083-.248.672-.81 1.12-.562.447-1.353.79-2.19.79s-1.63-.343-2.19-.79c-.563-.448-.81-1.037-.81-1.12 0-.081.247-.67.81-1.118.56-.447 1.352-.79 2.19-.79z","overflow":"visible"}}),_c('path',{attrs:{"d":"M9.016 9.524c-.743 0-1.364.62-1.364 1.363 0 .744.62 1.364 1.364 1.364s1.363-.62 1.363-1.364c0-.742-.62-1.363-1.363-1.363zm0 1.09c.141 0 .272.133.272.273 0 .142-.13.273-.272.273s-.273-.13-.273-.273c0-.14.13-.272.273-.272z","overflow":"visible"}})])])
          )
        }
      }
    